module.exports = __webpack_public_path__ + "img/logo2x.341e734f.png";